<div class="wrap">
  <div class="header">
    <h2 class="title">Ajouter une Notification</h2>
    <mat-slide-toggle
            class="example-margin"
            [color]="color"
            [checked]="isProg"
            (toggleChange)="isProg = !isProg"
            >
          {{isProg ?  'Programmée' : 'Directe'}}
        </mat-slide-toggle>
  </div>
  
  <form [formGroup]="addNotificationForm" (ngSubmit)="onSubmit()">
  
    <mat-form-field appearance="outline">
      <mat-label>Titre</mat-label>
      <input matInput type="text" formControlName="title">
    </mat-form-field>
  
    <mat-form-field appearance="outline">
      <mat-label>Contenu </mat-label>
      <textarea matInput formControlName="body"></textarea>
    </mat-form-field>
  
    <div class="dateTime" *ngIf="isProg">
      <mat-form-field appearance="outline">
        <mat-label>Date de programmation</mat-label>
        <input matInput [matDatepicker]="picker" formControlName="sendDate">
        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
        <mat-datepicker #picker></mat-datepicker>
      </mat-form-field>
    
      <mat-form-field appearance="outline">
        <mat-label>heure de programmation</mat-label>
        <input matInput type="time" formControlName="time">
      </mat-form-field>
    </div>
  
    <div class="btn_action">
      <button type="submit" class="confirm" [disabled]="addNotificationForm.invalid" [style.opacity]="addNotificationForm.valid ? 1 : .5">Ajouter la notification</button>
      <button type="button" class="back" (click)="dialogRef.close()">Anuler</button>
    </div>
  </form>
</div>